import { Autocomplete, AutocompleteProps, TextField, TextFieldProps } from '@mui/material';
import { ReactNode, memo } from 'react';
import { SxProps, Theme } from '@mui/material/styles';

const baseSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '10px',
  },
};

export type AppSelectProps<
  T,
  Multiple extends boolean | undefined = false,
  DisableClearable extends boolean | undefined = false,
  FreeSolo extends boolean | undefined = false,
> = Omit<AutocompleteProps<T, Multiple, DisableClearable, FreeSolo>, 'renderInput'> & {
  label?: ReactNode;
  textFieldProps?: Omit<TextFieldProps, 'label'>;
};

function AppSelectInner<
  T,
  Multiple extends boolean | undefined = false,
  DisableClearable extends boolean | undefined = false,
  FreeSolo extends boolean | undefined = false,
>({
  label,
  textFieldProps,
  sx,
  ...props
}: AppSelectProps<T, Multiple, DisableClearable, FreeSolo>) {
  const mergedSx: SxProps<Theme> = [baseSx, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])];
  return (
    <Autocomplete
      sx={mergedSx}
      renderInput={(params) => <TextField {...params} label={label} {...textFieldProps} />}
      {...props}
    />
  );
}

const AppSelect = memo(AppSelectInner) as typeof AppSelectInner;

export default AppSelect;
